import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5e82d8f7")

_pushScopeId("data-v-5e82d8f7")
const _hoisted_1 = { class: "PerformanceAnalysis" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("性能概况")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = {
  id: "delete",
  class: "displayIndicators spacName"
}
const _hoisted_5 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_6 = {
  key: 1,
  style: {"color":"#096534"}
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "keyPerformanceData spacName" }
const _hoisted_9 = { class: "keyLeft" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("关键性能数据")
], -1)
const _hoisted_11 = { class: "keyRight" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("性能趋势")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { id: "performanceTrends" }, null, -1)
const _hoisted_14 = { class: "performanceDataDetails" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("性能数据详情")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("i", { style: {"color":"red"} }, "↑"),
  /*#__PURE__*/_createVNode("i", { style: {"color":"#546e45"} }, "↓"),
  /*#__PURE__*/_createTextVNode(" :与前一次测试相比,下降或上升>10%的统计量 ")
], -1)
const _hoisted_17 = { class: "DataDetails" }
const _hoisted_18 = {
  key: 0,
  class: "index"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_20 = { class: "titleBG" }
const _hoisted_21 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("h5", null, "基础指标")
], -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "titleBG" }
const _hoisted_27 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("h5", null, "深度指标")
], -1)
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  key: 0,
  class: "titleBG"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("h5", null, "定制指标")
], -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("h5", null, "报告链接")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option_group = _resolveComponent("el-option-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")
  const _component_el_descriptions = _resolveComponent("el-descriptions")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, { style: {"width":"1500px","margin":"0 auto"} }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode("div", null, [
                      _hoisted_2,
                      _createVNode(_component_el_form, {
                        class: "spacName2",
                        size: "mini",
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "选择场景" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.selected_table_scene,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected_table_scene = $event)),
                                "collapse-tags": "",
                                placeholder: "请选择场景",
                                onChange: _ctx.selectTableChange
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.scene_id,
                                      label: item.chinese,
                                      value: item.scene_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "选择机型" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.selected_table_device,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selected_table_device = $event)),
                                "collapse-tags": "",
                                placeholder: "请选择机型",
                                onChange: _ctx.selectTableChange
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (group) => {
                                    return (_openBlock(), _createBlock(_component_el_option_group, {
                                      key: group.label,
                                      label: group.label
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "选择版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.selected_table_version,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selected_table_version = $event)),
                                "collapse-tags": "",
                                placeholder: "请选择版本",
                                onChange: _ctx.selectTableChange
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onTableClear()))
                              }, {
                                default: _withId(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_4, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.comparePerformanceAnalysis, (item, index) => {
                        return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
                          key: index,
                          style: {"width":"200px"}
                        }, {
                          default: _withId(() => [
                            _createVNode("p", null, [
                              _createTextVNode(_toDisplayString(item.value) + " ", 1),
                              (item.result > 0)
                                ? (_openBlock(), _createBlock("span", _hoisted_5, "(↑" + _toDisplayString(item.result) + ")", 1))
                                : (item.result < 0)
                                  ? (_openBlock(), _createBlock("span", _hoisted_6, "(↓" + _toDisplayString(item.result) + ")", 1))
                                  : (_openBlock(), _createBlock("span", _hoisted_7, "(" + _toDisplayString(item.result) + ")", 1))
                            ]),
                            _createVNode("p", null, _toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1536)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      }), 128))
                    ]),
                    _createVNode("div", _hoisted_8, [
                      _withDirectives(_createVNode("div", _hoisted_9, [
                        _createVNode(_component_el_descriptions, { column: 1 }, {
                          title: _withId(() => [
                            _hoisted_10
                          ]),
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.keyPerformanceData, (item) => {
                              return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                key: item.lable,
                                label: item.lable
                              }, {
                                default: _withId(() => [
                                  _createVNode("span", {
                                    onClick: ($event: any) => (_ctx.trendChart2(item.key, item.lable))
                                  }, _toDisplayString(item.value), 9, ["onClick"])
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_11, [
                        _createVNode("p", null, _toDisplayString(_ctx.echartTitle), 1),
                        _hoisted_12,
                        _hoisted_13
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _hoisted_16,
                      _withDirectives(_createVNode("div", _hoisted_17, [
                        (_ctx.PerformanceAnalysis.version_list.length !== 0)
                          ? (_openBlock(), _createBlock("table", _hoisted_18, [
                              _createVNode("tr", null, [
                                _hoisted_19,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerformanceAnalysis.nearby_seven_data, (item) => {
                                  return (_openBlock(), _createBlock("td", {
                                    key: item.url
                                  }, _toDisplayString(item.game_version), 1))
                                }), 128))
                              ]),
                              _createVNode("tr", _hoisted_20, [
                                _hoisted_21,
                                _createVNode("td", {
                                  colspan: _ctx.PerformanceAnalysis.nearby_seven_data.length
                                }, null, 8, ["colspan"])
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.basic, (item) => {
                                return (_openBlock(), _createBlock("tr", { key: item }, [
                                  _createVNode("td", null, [
                                    (_ctx.fields[item] === undefined)
                                      ? (_openBlock(), _createBlock("span", _hoisted_22, _toDisplayString(item), 1))
                                      : (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(_ctx.fields[item]), 1))
                                  ]),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerformanceAnalysis.nearby_seven_data, (item2) => {
                                    return (_openBlock(), _createBlock("td", {
                                      key: item2.url
                                    }, [
                                      (
                          item2[item] === '' ||
                          item2[item] === undefined ||
                          item2[item] === null
                        )
                                        ? (_openBlock(), _createBlock("span", _hoisted_24, "--"))
                                        : (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(item2[item]), 1))
                                    ]))
                                  }), 128))
                                ]))
                              }), 128)),
                              _createVNode("tr", _hoisted_26, [
                                _hoisted_27,
                                _createVNode("td", {
                                  colspan: _ctx.PerformanceAnalysis.nearby_seven_data.length
                                }, null, 8, ["colspan"])
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.advance, (item) => {
                                return (_openBlock(), _createBlock("tr", { key: item }, [
                                  _createVNode("td", null, [
                                    (_ctx.fields[item] === undefined)
                                      ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(item), 1))
                                      : (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.fields[item]), 1))
                                  ]),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerformanceAnalysis.nearby_seven_data, (item2) => {
                                    return (_openBlock(), _createBlock("td", {
                                      key: item2.url
                                    }, [
                                      (
                          item2[item] === '' ||
                          item2[item] === undefined ||
                          item2[item] === null
                        )
                                        ? (_openBlock(), _createBlock("span", _hoisted_30, "--"))
                                        : (_openBlock(), _createBlock("span", _hoisted_31, _toDisplayString(item2[item]), 1))
                                    ]))
                                  }), 128))
                                ]))
                              }), 128)),
                              (_ctx.customize.length !== 0)
                                ? (_openBlock(), _createBlock("tr", _hoisted_32, [
                                    _hoisted_33,
                                    _createVNode("td", {
                                      colspan: _ctx.PerformanceAnalysis.nearby_seven_data.length
                                    }, null, 8, ["colspan"])
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customize, (item) => {
                                return (_openBlock(), _createBlock("tr", { key: item }, [
                                  _createVNode("td", null, [
                                    (_ctx.fields[item] === undefined)
                                      ? (_openBlock(), _createBlock("span", _hoisted_34, _toDisplayString(item), 1))
                                      : (_openBlock(), _createBlock("span", _hoisted_35, _toDisplayString(_ctx.fields[item]), 1))
                                  ]),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerformanceAnalysis.nearby_seven_data, (item2) => {
                                    return (_openBlock(), _createBlock("td", {
                                      key: item2.url
                                    }, [
                                      (
                          item2[item] === '' ||
                          item2[item] === undefined ||
                          item2[item] === null
                        )
                                        ? (_openBlock(), _createBlock("span", _hoisted_36, "--"))
                                        : (_openBlock(), _createBlock("span", _hoisted_37, _toDisplayString(item2[item]), 1))
                                    ]))
                                  }), 128))
                                ]))
                              }), 128)),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customizedName, (item) => {
                                return _withDirectives((_openBlock(), _createBlock("tr", { key: item }, [
                                  _createVNode("td", null, [
                                    (_ctx.fields[item] === undefined)
                                      ? (_openBlock(), _createBlock("span", _hoisted_38, _toDisplayString(item), 1))
                                      : (_openBlock(), _createBlock("span", _hoisted_39, _toDisplayString(_ctx.fields[item]), 1))
                                  ]),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerformanceAnalysis.nearby_seven_data, (item2) => {
                                    return (_openBlock(), _createBlock("td", {
                                      key: item2.url
                                    }, [
                                      (
                          item2[item] === '' ||
                          item2[item] === undefined ||
                          item2[item] === null
                        )
                                        ? (_openBlock(), _createBlock("span", _hoisted_40, "--"))
                                        : (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(item2[item]), 1))
                                    ]))
                                  }), 128))
                                ], 512)), [
                                  [_vShow, _ctx.localProject === 7]
                                ])
                              }), 128)),
                              _createVNode("tr", null, [
                                _hoisted_42,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerformanceAnalysis.nearby_seven_data, (item) => {
                                  return (_openBlock(), _createBlock("td", {
                                    key: item.url
                                  }, [
                                    _createVNode("a", {
                                      target: "_blank",
                                      href: item.url
                                    }, "链接", 8, ["href"])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createBlock(_component_el_card, { key: 1 }, {
                              default: _withId(() => [
                                _createVNode(_component_el_empty, { "image-size": 100 })
                              ]),
                              _: 1
                            }))
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})